import { render, staticRenderFns } from "./FormComplemento.vue?vue&type=template&id=630a92ea&scoped=true&"
import script from "./FormComplemento.vue?vue&type=script&lang=js&"
export * from "./FormComplemento.vue?vue&type=script&lang=js&"
import style0 from "./FormComplemento.vue?vue&type=style&index=0&id=630a92ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630a92ea",
  null
  
)

export default component.exports